module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 372
// module chunks = 2